export default "__VITE_ASSET__3872a116__"